import { FC, ReactNode } from 'react';
import PageContainer from '@keyslabor/shared/ui/layout/PageContainer';
import { css } from 'styled-components';
import colors from '@keyslabor/shared/theme/colors.ts';
import PreloaderFullPage from '@/components/PreloaderFullPage';
import ContainerFullPage from '@/components/ContainerFullPage';
import { BoxProps, Button } from '@keyslabor/shared/ui';
import { PageContainerProps } from '@keyslabor/shared/ui/layout/PageContainer/PageContainer.tsx';

export interface LayoutContainerProps extends PageContainerProps {
  rootBoxProps?: Partial<BoxProps>;
  children?: ReactNode;
  header?: ReactNode;
  footer?: ReactNode;
  loading?: boolean;
  error?: boolean;
  errorInfo?: string;
  onBackToStartClick?: () => void;
}

const LayoutContainer: FC<LayoutContainerProps> = (props) => {
  const {
    children,
    header,
    footer,
    loading,
    error,
    errorInfo,
    onBackToStartClick,
    ...restProps
  } = props;
  const isLoading = loading && !error;

  return (
    <PageContainer
      py="0"
      pt="20px"
      overflow="hidden"
      height="100%"
      position="relative"
      minHeight="100dvh"
      css={css`
        & {
          min-height: 100vh;
          min-height: 100dvh;
        }
      `}
      width="100%"
      backgroundColor={colors.whitesmoke}
      display="grid"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      gridTemplateRows={`${header ? 'max-content' : ''} 1fr ${
        footer ? 'max-content' : ''
      }`}
      {...restProps}
      {...(isLoading && { pt: '0 !important' })}
    >
      {isLoading && <PreloaderFullPage />}
      <>
        {header}
        {children}
        {footer}
      </>
      {error && (
        <ContainerFullPage>
          {errorInfo ?? 'Something went wrong. Please try again later'}
          {onBackToStartClick ? (
            <Button
            variant="primary"
            size="lg"
            mt="20px"
            onClick={onBackToStartClick}
          >
            Restart
          </Button>
          ): null}
        </ContainerFullPage>
      )}
    </PageContainer>
  );
};

export default LayoutContainer;